import RequestAbstract from "../abstract";

export default class RolesActionsPermissions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/cabinet/roles-actions-permissions";
    }

}
